import React from 'react';
import AdList from '../components/ad-list';
import Layout from '../components/layout';
import LinkButton from '../components/link-button';
import PageHeader from '../components/page-header';
import './page.css';

const AdsPage = () => (
  <Layout>
    <div className="page">
      <PageHeader
        title="Publicités"
        description="Créer, éditer ou supprimer des publicités."
      />

      <div className="page_actions">
        <LinkButton
          className="page_action-button"
          icon="add"
          label="Créer une publicité"
          to="/publicites/creer"
          theme="success"
        />
      </div>

      <AdList />
    </div>
  </Layout >
);

export default AdsPage;
